import type { AlertSettings, AlertSettingsInput, ConnectionTestResult } from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/** Onglet Alertes (`02` §12.5). */
export function fetchAlertSettings(): Promise<AlertSettings> {
  return apiFetch<AlertSettings>('/api/settings/alerts');
}

export function updateAlertSettings(body: AlertSettingsInput): Promise<AlertSettings> {
  return apiFetch<AlertSettings>('/api/settings/alerts', { method: 'PUT', body });
}

export function testAlertEmail(): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/settings/alerts/test-email', { method: 'POST' });
}

export function testAlertSlack(): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/settings/alerts/test-slack', { method: 'POST' });
}
